/* eslint-disable */
import createIcon from '../createIcon';

const IconSave = createIcon({
  name: 'icon-save',
  content: '<title>ic_保存</title><defs><rect id="icon-save-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1075.000000, -5107.000000)"><g transform="translate(498.000000, 4920.000000)"><g transform="translate(111.000000, 187.000000)"><g transform="translate(466.000000, 0.000000)"><mask id="icon-save-b" fill="currentColor"><use xlink:href="#icon-save-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-save-a"/><path d="M15,1 L15,15 L1,15 L1,1 L15,1 Z M4,8 L4,2 L2,2 L2,14 L14,14 L14,2 L13,2 L13,8 L4,8 Z M9.5,2 L5,2 L5,7 L12,7 L12,2 L10.5,2 L10.5,6 L9.5,6 L9.5,2 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-save-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconSave;
